import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
import { isProgramIncentivesRestorationEnabled } from '../utils/incentives';
import { getSelectedIncentiveIdsFromPenciledInputs } from './incentiveSelectors';

export const getSelectedIncentives = (state: OfferReduxBaseState): number[] => {
    if (isProgramIncentivesRestorationEnabled(state)) {
        return getSelectedIncentiveIdsFromPenciledInputs(state);
    }
    return state?.programs?.selectedIncentives || [];
};
